<template>
  <div class="container-fluid mt-3">
    <h2>Pricing Management</h2>
    <p class="text-muted">Manage global price, premium and trade data</p>

    <!-- Tab Navigation -->
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'live' }"
          @click="setActiveTab('live')"
          type="button"
        >
          Live Dashboard
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'prices' }"
          @click="setActiveTab('prices')"
          type="button"
        >
          Prices
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'premiums' }"
          @click="setActiveTab('premiums')"
          type="button"
        >
          Premiums
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'trades' }"
          @click="setActiveTab('trades')"
          type="button"
        >
          Trades
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'weekly-stats' }"
          @click="setActiveTab('weekly-stats')"
          type="button"
        >
          Weekly Stats
        </button>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content mt-4">
      <LiveDashboardTabComponent v-if="activeTab === 'live'" />
      <PricesTabComponent v-if="activeTab === 'prices'" />
      <PremiumsTabComponent v-if="activeTab === 'premiums'" />
      <TradesTabComponent v-if="activeTab === 'trades'" />
      <WeeklyStatsTabComponent v-if="activeTab === 'weekly-stats'" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

import LiveDashboardTabComponent from "@/market_insights/admin/LiveDashboardTabComponent.vue";
import PremiumsTabComponent from "@/market_insights/admin/PremiumsTabComponent.vue";
import PricesTabComponent from "@/market_insights/admin/PricesTabComponent.vue";
import TradesTabComponent from "@/market_insights/admin/TradesTabComponent.vue";
import WeeklyStatsTabComponent from "@/market_insights/admin/WeeklyStatsTabComponent.vue";

const route = useRoute();
const router = useRouter();

const TABS = ["live", "prices", "premiums", "trades", "weekly-stats"];

const normalizeTab = (tab: unknown): string =>
  typeof tab === "string" && TABS.includes(tab) ? tab : "live";

const activeTab = ref(normalizeTab(route.query.tab));

const setActiveTab = (tab: string) => {
  activeTab.value = tab;
  router.push({ query: { ...route.query, tab } });
};

watch(
  () => route.query.tab,
  (newTab) => {
    activeTab.value = normalizeTab(newTab);
  }
);
</script>

<style lang="scss" scoped>
.tab-content {
  min-height: 500px;
}
</style>
